module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "rank"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      staticClass: "grid"
    }, [_c('h2', {
      staticClass: "col"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('rank-view', {
      attrs: {
        "proitems": item.proitems,
        "rankers": item.rankers
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f0c4cca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Rank.vue
// module id = 584
// module chunks = 0